export default __webpack_public_path__ + "static/media/check-circle.4fad00f2.svg";